import { render, staticRenderFns } from "./ConstructionPage.vue?vue&type=template&id=58a1c1f6&"
import script from "./ConstructionPage.vue?vue&type=script&lang=js&"
export * from "./ConstructionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports